import DetectorInterface from "../DetectorInterface";
import Detector from '../Detector';

export default class Number extends Detector implements DetectorInterface {

    public match(value: string): boolean {

        if (typeof value !== 'number') return false;

        return /^-{0,1}\d+$/.test(value);
    }
}
